/* eslint-disable max-len */
import React from 'react';

import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  typography: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: '700',
    paddingTop: '15px',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '25px',
      fontSize: '30px',
    },
  },
  divider: {
    // Theme Color, or use css color in quote
    height: '5px',
    background: '#FFAA05',
  },
  li: {
    marginLeft: '0px',
    paddingBottom: '7px',
  },
  text: {
    padding: '0px',
    fontFamily: 'Barlow',
    fontSize: '17px',
    lineHeight: '20px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '24px',
      lineHeight: '28px',
      padding: '0px',
    },
  },
}));

export default function Committee() {
  const classes = useStyles();
  const scientific = [
    'Arkadiusz Płoski, Kielce University of Technology (Polonia)',
    'Benito Leonardo Ostos Cordero, Universidad Nacional de Ingeniería (Perú)',
    'Evelia Rosa García Barroso, Universidad de La Laguna (España)',
    'Gabriel Armando Muñoz Márquez, Universidad Nacional Mayor de San Marcos (Perú)',
    'Mauro Fernando Hernández Iglesias, Universidad Nacional Mayor de San Marcos (Perú)',
    'Marcelo Escudeiro Hernandes, Universidade Estadual de Maringá (Brasil)',
    'Roland Rabanal, Pontificia Universidad Católica del Perú. (Perú)',
  ];
  const teachers = [
    ['Alfonso Pérez Salvatierra', ' (Decano de la Facultad de Ciencias Matemáticas)'],
    'Gabriel Armando Muñoz Márquez',
    'Luz Teresa Quispe Vega',
    'María del Carmen Cáceres Huamán',
    'Martha Olinda Gonzalez Bohorquez',
    'Maruja Yolanda Gavilán Gonzales',
    'Mauro Fernando Hernández Iglesias',
    'Miriam Gisell Percorán Florencio',
    'Rosa Luz Medina Aguilar',
  ];
  const students = [
    'Bryan Alejandro Cueva Cortéz',
    'Joaquín Alfonso Castillo Vilcahuaman',
    'Romel Jesús Huerta Sanchez',
    'Yumari Faríd Cruz Reyes',
  ];
  return (
    <div>
      <Typography variant="h1" className={classes.typography}>
        Comité Científico
      </Typography>
      <Divider classes={{ root: classes.divider }} />
      <Typography variant="h6" className={classes.text}>
        <ul style={{ marginLeft: '0px' }}>
          {
            scientific.map((scy) => (<li className={classes.li}>{scy}</li>
            ))
          }
        </ul>
      </Typography>
      <Typography variant="h1" className={classes.typography}>
        Comité Organizador - Universidad Nacional Mayor de San Marcos
      </Typography>
      <Divider classes={{ root: classes.divider }} />
      <Typography variant="h6" className={classes.text}>
        <h4 style={{ marginLeft: '10px' }}>Docentes:</h4>
        <ul style={{ marginLeft: '0px' }}>
          {
            teachers.map((scy, index) => (
              (index === 0) ? (
                <li className={classes.li}>
                  {scy[0]}
                  <em>{scy[1]}</em>
                </li>
              ) : <li className={classes.li}>{scy}</li>
            ))
          }
        </ul>
        <h4 style={{ marginLeft: '10px' }}>Alumnos:</h4>
        <ul style={{ marginLeft: '0px' }}>
          {
            students.map((scy) => (
              <li className={classes.li}>
                {scy}
              </li>
            ))
          }
        </ul>
      </Typography>
    </div>
  );
}
